import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerPaymentInformationComponent } from './customer-payment-information.component';
import { AuthGuard } from '../../../core/services/authGuard';
import { RoleGuard } from '../../../core/services/roleGuard';

const routes: Routes = [
  {
    path: 'payment-information',
    component: CustomerPaymentInformationComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Customer'] },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerPaymentInformationRoutingModule {}
